module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "live-chat"
    }
  }, [_c('div', {
    staticClass: "chat"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.viewComments
    }
  }, [_vm._v("Kommentare anzeigen (" + _vm._s(_vm.nameRef.totalComment) + ")")])]), _vm._v(" "), (_vm.showComments) ? _c('div', {
    staticClass: "chat-history"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentMsg),
      expression: "commentMsg"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Kommentar schreiben...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.commentMsg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentMsg = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.comment($event)
      }
    }
  }, [_vm._v("Kommentieren")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.sortedComments), function(comment) {
    return _c('ChatMessage', {
      key: comment['.key'],
      attrs: {
        "message": comment.comment,
        "userName": comment.user,
        "datum": comment.dateTime
      }
    })
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d3ff4dd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
// module id = 124
// module chunks = 1